<template>
  <div :style="style" class="flex flex-col flex-grow max-w-screen-sm mx-auto">
    <div class="p-6 mt-6 text-center bg-color">
      <svg-error width="50" height="50" class="mx-auto mb-4"></svg-error>
      <slot>
        <p>An error encountered while loading this component.</p>
        <p>Please reload the page to try again.</p>
      </slot>
    </div>
  </div>
</template>

<script>
import SvgError from "@/components/Svg/SvgError";

export default {
  components: {
    SvgError,
  },
  computed: {
    style() {
      return {
        "--bg-color":
          this.$store.state.config?.colors?.containerBackground || "#FFFFFF",
      };
    },
  },
  created() {
    this.$store.commit("fieldUpdate", {
      key: "isError",
      value: true,
    });
  },
  destroyed() {
    this.$store.commit("fieldUpdate", {
      key: "isError",
      value: false,
    });
  },
};
</script>

<style scoped>
.bg-color {
  background-color: var(--bg-color);
}
</style>
